import { Grid, Stack } from "@mui/material";
import React from "react";

const PaidBy = () => {
  return (
    <Grid container spacing={1} className="w-full">
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Employee Name
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Gokulnath
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Loan Type
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Personal Loan
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Loan Amount
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        18,000.00
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Mode of Payment
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Cheque
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Ref Number
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        CHQ#009856
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Payment Date
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        05/10/2023
      </Grid>
    </Grid>
  );
};

export default PaidBy;
